import { cn } from '@lyearn/style';
import { Editor } from '@/components/Editor';
import { PlainEditorProps, ToolbarOption } from '@/components/Editor/PlainEditor/types';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { Maybe } from '@/types/schema';

type Props = {
  error?: boolean;
  multiline?: boolean;
  allowAttachments?: Maybe<boolean>;
} & Pick<
  PlainEditorProps,
  | 'className'
  | 'disabled'
  | 'medias'
  | 'value'
  | 'variant'
  | 'placeholder'
  | 'onChangeMedias'
  | 'onChangeText'
>;

const EMPTY_ARRAY: never[] = [];
const editorOptions = [ToolbarOption.AttachFile];
const classes = { toolbar: { root: 'absolute bottom-10 end-8', container: '!p-0' } };
const editorCoreClasses = { typography: '!min-h-[4.8rem] !max-h-[9rem] me-[7.2rem]' };
const editorCoreMultilineClasses = { typography: '!min-h-[11.8rem] !max-h-[20rem] me-[7.2rem]' };

const UserSurveyRichTextInput = (props: Props) => {
  const { id } = useUserContext();
  const { className, error, multiline, allowAttachments, ...rest } = props;

  return (
    <Editor
      hideToolbarDivider
      attachmentPosition="top"
      className={cn(
        'rounded-8 border',
        error ? 'border-border-error-dark' : 'border-field',
        className,
      )}
      classes={classes}
      editorCoreClasses={multiline ? editorCoreMultilineClasses : editorCoreClasses}
      editorOptions={allowAttachments && id ? editorOptions : EMPTY_ARRAY}
      variant="body-short-01"
      {...rest}
    />
  );
};

export default UserSurveyRichTextInput;
